import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { SIZE, Switch } from '@tmapy/style-guide';
import { changePageMargins } from '../actions';
import { LocaleContext } from '../LocaleContext';
export const MarginsOption = ({ label }) => {
    const dispatch = useDispatch();
    const margins = useSelector((state) => state.page.margins);
    const handleChange = (e) => {
        dispatch(changePageMargins(e.target.checked));
    };
    return (_jsx(LocaleContext.Consumer, { children: (context) => (_jsx(Switch, { size: SIZE.SML, isChecked: margins, onChange: handleChange, tooltip: `${context.locale.settingsItemSwitch} "${label}"`, children: _jsx("span", { className: 'rpx-u-type-formItemLabel', children: label }) })) }));
};
//# sourceMappingURL=MarginsOption.js.map